export default __webpack_public_path__ + "static/media/r&d-cost.aa26ee2d.svg";